// Lib
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';


export interface ActionGetUrlUpgradePackageAPI extends Action {
    dealerId: string;
    connection?: string;
}


export const getUrlUpgradePackageAPI = (dealerId: string, connection?: string): ActionGetUrlUpgradePackageAPI => ({
    type: ACTIONS.GET_URLUPGRADE_PACKAGE_API_REQUEST,
    dealerId,
    connection
});
;


export interface ActionGetUrlUpgradePackageAPISuccess extends Action {
    url: string
}

export const getUrlUpgradeAPISuccess = (url: string): ActionGetUrlUpgradePackageAPISuccess => ({
    type: ACTIONS.GET_URLUPGRADE_PACKAGE_API_SUCCESS,
    url
});

export interface ActionGetUrlEliteRedirectAPISuccess extends Action {
    urElite: string
}

export const getUrlEliteRedirectAPISuccess = (urElite: string): ActionGetUrlEliteRedirectAPISuccess => ({
    type: ACTIONS.GET_ELITE_REDIRECT_API_SUCCESS,
    urElite
});

export const getUrlUpgradeAPIError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_URLUPGRADE_PACKAGE_API_ERROR,
    error
});